/* eslint-disable import/order */
import { StrictMode } from 'react';

import Clarity from '@microsoft/clarity';
import * as Sentry from '@sentry/react';

import 'leaflet/dist/leaflet.css';
import './styles/global.less';

import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import localeData from 'dayjs/plugin/localeData';
import weekday from 'dayjs/plugin/weekday';
import weekOfYear from 'dayjs/plugin/weekOfYear';
import weekYear from 'dayjs/plugin/weekYear';
import ReactDOM from 'react-dom/client';

import { CLARITY_PROJECT_ID } from '@/config/environment';
import App from './App';
import reportWebVitals from './reportWebVitals';

dayjs.extend(customParseFormat);
dayjs.extend(advancedFormat);
dayjs.extend(weekday);
dayjs.extend(localeData);
dayjs.extend(weekOfYear);
dayjs.extend(weekYear);

Sentry.init({
  dsn: `https://aa88b83b674b4c27bd403f0200859af3@o454934.ingest.sentry.io/4505127621165056`,
  integrations: [new Sentry.BrowserTracing()],
  tracesSampleRate: 1.0,
});

if (CLARITY_PROJECT_ID) {
  Clarity.init(CLARITY_PROJECT_ID);
}

const root = ReactDOM.createRoot(document.getElementById(`root`) as HTMLElement);

root.render(
  <StrictMode>
    <App />
  </StrictMode>,
);

reportWebVitals();
